import { useState } from 'react';
import { Input, InputGroup, Form, Whisper, Tooltip } from 'rsuite';
import './basicInput.css';
import EyeCloseIcon from '@rsuite/icons/EyeClose';
import VisibleIcon from '@rsuite/icons/Visible';
import ReloadIcon from '@rsuite/icons/Reload';
import { Icon } from '@rsuite/icons';

export default function BasicInput({
        label,
        placeholder,
        onChange,
        value,
        helpText,
        flexible,
        error,
        textarea,
        disabled,
        helpTextHighlight,
        isPassword = false,
        cleanable = false,
        addonAfter,
        onFocus,
        ...props
    }) {

    const [visible, setVisible] = useState(false);

    if (flexible && !label && value) {
        label = placeholder;
    }

    if (error) {
        console.log(error);
    }

    return (
        <Form.Group>
            <InputGroup inside className={`basicInputGroup ${error ? "error" : ""} ${textarea ? "textarea" : ""}`}
            {...props}>
                <InputGroup.Addon className={`basicInputAddon paragraph-10R ${label ? 'withLabel' : 'noLabel'}`}>
                    {label}
                </InputGroup.Addon>
                
                {
                    !cleanable ?
                    addonAfter ? (
                        <InputGroup className="basicInputInnerGroup">
                            <Input
                                disabled={disabled}
                                as={textarea ? 'textarea' : 'input'}
                                type={isPassword ? (visible ? 'text' : 'password') : 'text'}
                                onChange={(value, e) => onChange(value, e)}
                                onFocus={onFocus}
                                value={value}
                                className={`${label ? 'withLabel' : 'noLabel'} paragraph-14R ${textarea ? "textarea" : ""}`}
                                placeholder={placeholder}
                            />
                            <InputGroup.Addon>
                                {addonAfter}
                            </InputGroup.Addon>
                        </InputGroup>
                    ) : (
                        <Input
                            disabled={disabled}
                            as={textarea ? 'textarea' : 'input'}
                            type={isPassword ? (visible ? 'text' : 'password') : 'text'}
                            onChange={(value, e) => onChange(value, e)}
                            onFocus={onFocus}
                            value={value}
                            className={`${label ? 'withLabel' : 'noLabel'} paragraph-14R ${textarea ? "textarea" : ""}`}
                            placeholder={placeholder}
                        />
                    ) :
                    <div style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <Input
                            as={textarea ? 'textarea' : 'input'}
                            type={isPassword ? (visible ? 'text' : 'password') : 'text'}
                            onChange={(value, e) => onChange(value)}
                            onFocus={onFocus}
                            value={value}
                            className={`${label ? 'withLabel' : 'noLabel'} paragraph-14R ${textarea ? "textarea" : ""}`}
                            placeholder={placeholder}
                        />

                        {addonAfter && (
                            <InputGroup.Addon>{addonAfter}</InputGroup.Addon>
                        )}

                        <InputGroup.Addon className={`basicInputCleanable`}>
                            {<ReloadIcon onClick={() => onChange('')} />}
                        </InputGroup.Addon>
                    </div>
                }

                {isPassword && (
                    <button
                        className="eyeButton"
                        onClick={() => setVisible(!visible)}
                        type="button"
                    >
                        {visible ? <VisibleIcon /> : <EyeCloseIcon />}
                    </button>
                )}
            </InputGroup>
            { helpText &&
                <Form.HelpText
                    className={'basicInputHelpText paragraph-10R ' + helpTextHighlight ? "highlight" : ""}
                >{helpText}</Form.HelpText>
            }
        </Form.Group>
    );
}